import React, { useContext } from 'react'

import { PipelineStoreContext } from '../../contexts'
import PipelineStore from '../../store/PipelineStore'

const usePipelineStore = (): PipelineStore => {
   const pipelineStore = useContext(PipelineStoreContext)

   if (!pipelineStore) {
      throw new Error('Expected to be wrapped in pipeline Store Provider')
   }

   return pipelineStore
}

export { usePipelineStore }
